import { addConfigToServiceFunction } from "@montana/services/http";
import { useDynamicSettings } from "@montana/containers/dynamic-settings";
import { IRequestHeaderConfig, OmitConfig } from "@montana/models/dev";
import { useSettings } from "@montana/containers/settings/settings.container";

type FunctionWithConfig = (c: IRequestHeaderConfig, ...args: any[]) => any;

export function useConnectedServiceFunctions<T1 extends FunctionWithConfig>(f1: T1): [OmitConfig<T1>];
export function useConnectedServiceFunctions<T1 extends FunctionWithConfig, T2 extends FunctionWithConfig>(f1: T1, f2: T2): [OmitConfig<T1>, OmitConfig<T2>];
export function useConnectedServiceFunctions<T1 extends FunctionWithConfig, T2 extends FunctionWithConfig, T3 extends FunctionWithConfig>(f1: T1, f2: T2, f3: T3): [OmitConfig<T1>, OmitConfig<T2>, OmitConfig<T3>];
export function useConnectedServiceFunctions<TFunctions extends Array<(c: IRequestHeaderConfig, ...args: any[]) => any>>(...serviceFunctions: TFunctions) {
    const { language } = useDynamicSettings();
    const { market, customerMode } = useSettings();

    return serviceFunctions.map(f => addConfigToServiceFunction({ market, language, customerMode }, f));
}
